import {
  GCS_PATH_IDS,
  getImageKeyFromPath,
  request_access as requestAccess,
  upload_file_gcs as uploadFileGcs,
} from '~/common/storage/gcs_storage';

/**
 * Uploads a file to gcs and return the photo ID
 * @param eventId
 * @param guestId
 * @param photo
 * @param progressCb callback to report progress
 * @param width photo width
 * @param height photo height
 * @returns int photo ID
 */
export const uploadPhoto = async ({eventId, guestId, photo, progressCb, width, height}) => {
  const path = GCS_PATH_IDS.feed_photos;
  const params = {
    event_id: eventId,
    photo_id: '',
    guest_id: guestId,
  };

  const body = {redirect: true, mimetype: photo.file.type, width, height};

  const uploadRequest = await requestAccess(path, params, body);
  const success = await uploadFileGcs(uploadRequest, photo.file, progressCb);
  return success ? getImageKeyFromPath(uploadRequest.gcs_path) : null;
};
